import { TurmaApiResponse } from '../../../services/service.types';
import { Mapper, ParaTurmaCursadaProps } from './para-turma-cursada.types';

export const paraTurmaCursada: Mapper<ParaTurmaCursadaProps> = ({ apiResponse, turmasCursadasUsuario }) =>
  apiResponse.map((item: TurmaApiResponse) => ({
    ...item,
    ...turmasCursadasUsuario.find((turma) => turma.id === item.id),
  }));
